import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { BodyListResponse } from 'src/app/core/models/general/body-list-response';
import { BodyResponse } from 'src/app/core/models/general/body-response';

import { CronogramaActividadesParticipantesDTO } from 'src/app/core/models/vinculacion/vinculacion-Interfaces';

import { environment } from 'src/environments/environment';

const API_URL = environment.apiUrlVinculacion;

@Injectable()
export class CronogramaActividadesParticipantesService {
  header = new Headers({ 'Content-Type': 'application/json' });

  constructor(private http: HttpClient) { }

  getCronogramaActividadesParticipantesService(): Observable<BodyListResponse<CronogramaActividadesParticipantesDTO>> {
    return this.http.get<BodyListResponse<CronogramaActividadesParticipantesDTO>>(API_URL + '/api/v1/cronogramaActividadesParticipantes/todos');
  }

  guardarCronogramaActividadesParticipantesService(cronogramaActividadesParticipantesDTO: CronogramaActividadesParticipantesDTO): Observable<BodyResponse<CronogramaActividadesParticipantesDTO>> {
    return this.http.post<any>(API_URL + '/api/v1/cronogramaActividadesParticipantes', cronogramaActividadesParticipantesDTO);
  }

  getCronogramaActividadesParticipantesPorCodigoService(codigo: string): Observable<BodyResponse<CronogramaActividadesParticipantesDTO>> {
    return this.http.get<BodyResponse<CronogramaActividadesParticipantesDTO>>(API_URL + '/api/v1/cronogramaActividadesParticipantes/' + codigo);
  }

  getCronogramaActividadesParticipantesPorParticipanteService(codigoParticipante: string): Observable<BodyListResponse<CronogramaActividadesParticipantesDTO>> {
    return this.http.get<BodyListResponse<CronogramaActividadesParticipantesDTO>>(API_URL + '/api/v1/cronogramaActividadesParticipantes/participante/' + codigoParticipante);
  }

}
